import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.50015 7.91424L6.91436 2.50003L5.50015 1.08582L0.0859375 6.50003L1.50015 7.91424Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.9144 6.50003L18.5002 1.08582L17.0859 2.50003L22.5002 7.91424L23.9144 6.50003Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.0002 3.00003C6.4773 3.00003 2.00015 7.47718 2.00015 13C2.00015 18.5229 6.4773 23 12.0002 23C17.523 23 22.0002 18.5229 22.0002 13C22.0002 7.47718 17.523 3.00003 12.0002 3.00003ZM15 17.4142L11 13.4142V7.5H13V12.5858L16.4142 16L15 17.4142Z"}}]};

const AlarmFilled = Vue.extend<IconProps>({
  name: 'AlarmFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'alarm-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AlarmFilled;
